import { APP_CONFIG } from 'src/app/app.config';
import { SortOrder } from 'src/app/app.constants';

export const CANDIDATE_CONFIG = {
  requests: {
    create: {
      name: 'createCandidate',
      url: `${APP_CONFIG.apiBaseUrl}/candidate/publicPage`,
    },
    findCandidate: {
      name: 'findCandidate',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/candidate/${uuid}`,
    },
    getStatusList: {
      name: 'getStatusList',
      url: `${APP_CONFIG.apiBaseUrl}/candidate/status-list`,
    },
    search: {
      name: 'searchCandidate',
      url: `${APP_CONFIG.apiBaseUrl}/candidate`,
    },
    saveCandidateDocument: {
      name: 'saveCandidateDocument',
      url: `${APP_CONFIG.apiBaseUrl}/candidate/publicPage/documents`,
    },
    checkEmailExist: {
      name: 'checkEmailExist',
      url: `${APP_CONFIG.apiBaseUrl}/candidate/check`,
    },
    getCandidateDocument: {
      name: 'getCandidateDocument',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/candidate/${uuid}/document`,
    },
    getDocument: {
      name: 'getDocument',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/candidate/document/${uuid}`,
    },
    getCandidateComment: {
      name: 'getCandidateComment',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/candidate/${uuid}/comments`,
    },
    updateCandidate: {
      name: 'updateCandidate',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/candidate/${uuid}`,
    },
    deleteDocument: {
      name: 'deleteDocument',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/candidate/document/${uuid}`,
    },
    deleteCandidate: {
      name: 'deleteCandidate',
      url: (uuid) => `${APP_CONFIG.apiBaseUrl}/candidate/${uuid}`,
    },
    getStatusActions: {
      name: 'getStatusActions',
      url: (uuid, processId) => `${APP_CONFIG.apiBaseUrl}/candidate/${uuid}/${processId}/statusAction`,
    },
    executeStatusAction: {
      name: 'executeStatusAction',
      url:  (uuid, processId) => `${APP_CONFIG.apiBaseUrl}/candidate/${uuid}/process/${processId}`
    },
    saveCv: {
      name: '  saveCv',
      url: `${APP_CONFIG.apiBaseUrl}/candidate/publicPage/cv`,
    },
  },
  defaultSortField: 'updated',
  defaultSortOrder: SortOrder.Desc,
};
